/* unplugin-vue-components disabled */import { render } from "./DcSelectBox.vue?vue&type=template&id=a8c1a780"
import script from "./DcSelectBox.vue?vue&type=script&lang=js"
export * from "./DcSelectBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__